export const LOAD_PRACTICE = 'LOAD_PRACTICE';
export const LOADED_PENDING_PRACTICES = 'LOADED_PENDING_PRACTICES';

export interface PracticeState {
  current?: Practice;
  invitations: Invitation[];
  pending: PracticeMap;
}

interface LoadedPendingPracticesAction {
  type: typeof LOADED_PENDING_PRACTICES;
  invitations: Invitation[];
  pending: PracticeMap;
}

interface LoadPracticeAction {
  type: typeof LOAD_PRACTICE;
  practice: Practice;
}

export type PracticeActions = LoadedPendingPracticesAction | LoadPracticeAction;
